// extracted by mini-css-extract-plugin
export default {"wrap":"lG-z","articleImagesWrap":"mG-z","articleImage":"nG-z","singleImage":"oG-z"};